
const aboutIPO = {
    "About IPOs": [
        {
          question: "How does an IPO application through UPI work?",
          answer: "Public issue application using UPI is a digital mode to apply for IPO. An overview of the process is as follows :"
          +
            "<br />"+
            `<ul>
            <li>Create a UPI ID and PIN using any of the UPI enabled mobile application</li>
            <li>Go to any platform offering NCD IPO and enter your UPI ID along with bid details</li>
            <li>Accept the request to block the funds for the amount you have bid by entering your UPI PIN in the mobile application like Google Pay of PhonePe.</li>
            <li>The money shall be blocked and shall be automatically remitted to the Bank, in case of allotment.</li>
             <ul>`
        },
        {
          question: "Can I use an existing UPI ID for applying in public issues?",
          answer: "Yes. The existing UPI ID can be used"
        },
        {
          question: "Which are the list of supported UPI Apps?",
          answer: "The National Payments Corporation of India has permitted 24 UPI apps for IPO.<br />" +
            "<b>Here is the list of those 24 apps and their handles." +
            "<br /><br />" + "<a href='https://www.npci.org.in/what-we-do/ipo/live-partners'  target='_blank'>https://www.npci.org.in/what-we-do/ipo/live-partners</a> <br /> <br />" + 
            "The total length of the UPI ID does not exceed 45 characters (e.g. the UPI ID XYZ@UPI is 7 characters)."
        },
        {
          question: "How to accept the UPI payment mandate?",
          answer: "Your bank through which UPI ID was created will send you an SMS requesting approval of the payment via UPI. You can go to the respective UPI app and approve the payment. By approving the payment, you are accepting the mandate."
        },
        {
          question: "What if I erroneously decline the request to block funds?",
          answer: "You can re-initiate a new transaction through the Bidd platform."
        },
        {
          question: "What is the per application limit to apply for ASBA through UPI?",
          answer: "NPCI has set a transaction limit of 5 lakhs in the UPI-based payments on the instant   inter-bank fund transfer mechanism. Hence, you can't invest more than RS. 5 lakhs."
        },
        {
          question: "Can I Invest more than 5 lakhs in the NCD IPO?",
          answer: "Yes, under the HNI category for investment you can apply for an investment amount greater than 10 Lakhs.  The process to apply under HNI category is offline, and investors have to fill ASBA application form and courier it to the Bidd office. For more details please reach out to us at connect@biddeasy.com"
        },
        {
          question: "What happens if I do not get any shares under the public issue process for applications made using UPI for payment?",
          answer: "In case you do not get any share allotment, the amount blocked in your account will be released."
        },
        {
          question: "How to find DP ID and Client ID?",
          answer: "You can find your DP ID and Client ID in the profile section of your broking account with platforms like Zerodha, ICICI Direct, Angel Broking etc."
        },
        {
          question: "If my application gets rejected, when will my fund be released?",
          answer: "After you subscribe to an IPO, ASBA blocks the application amount in your bank account. In the case your IPO application gets rejected, the amount will be released within 1 or 2 working days."
        },
        {
          question: "Where can I get more details about  IPO applications through UPI?",
          answer: "You can visit NPCI website for more details <a href='https://www.npci.org.in/what-we-do/ipo/faqs'>https://www.npci.org.in/what-we-do/ipo/faqs</a>"
        },
        {
          question: "Why was my application rejected? ",
          answer: "There could be multiple reasons. Some of the common reasons are as follows:" +
          `<ul>
          <li>The applicant gives an invalid or incorrect DP ID / Client ID</li>
          <li>The PAN given in the IPO application is not matching with the PAN associated with the given Demat account.</li>
          <li>The given Demat account number is wrong.</li>
          <li>The given Demat account is inactive.</li>
          <li>If the Demat account is not accessed for a long time, the Demat account becomes Dormant. The maximum duration Demat account can remain unused before it becomes dormant will be mentioned in an agreement made with DP. By paying reactivation fees to your DP, the Demat account can be reactivated.</li>
          <li>If the UPI mandate is not accepted within 48 hours of placing the application</li>
          <li>The given UPI handle is invalid</li>
           <ul>`
        },
        {
          question: "How to accept the UPI payment mandate?",
          answer: "Once you submit your IPO application, your Bank will send you an SMS requesting    approval of the payment via UPI. You can go to the respective UPI app and approve the payment. By approving the payment, you are accepting the mandate."
        },
        {
          question: "How do I know my allotment status?",
          answer: "Once the securities are allotted in an IPO, investors will be informed via email and SMS. To check allotment status, investors can visit the registrar’s website or BSE/NSE website. By providing your application number and PAN, you can check the allotment status. <br /> <br />" +
          "If you have applied for an IPO via Bidd, you can check your allotment status on our platform in the IPO order page under Order history."
        },
      ],
  }
  
  export default aboutIPO;